export function setChartOptions(options) {
  const chartOptions = {
    xAxis: {
      type: 'category',
      data: options.xAxisData,
      min: 0,
      axisLabel: {
        textStyle: {
          color: '#999',
        },
        showMaxLabel: true,
        showMinLabel: true,
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      boundaryGap: false,
    },
    yAxis: {
      type: 'value',
      name: '收益',
      nameTextStyle: {
        color: '#999',
        align: 'right',
      },
      axisLabel: {
        textStyle: {
          color: '#999',
        },
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
      },
    },
    series: [
      {
        data: options.yAxisData,
        type: 'line',
        lineStyle: {
          color: '#326be0',
        },
        itemStyle: {
          opacity: 0,
          // borderColor: '#ecca9a',
        },
        symbolSize: 10,
      },
    ],
    grid: {
      left: 50,
      top: 40,
      right: 20,
      bottom: 25,
    },
  };
  return chartOptions;
}
